import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { toastNotify } from '../../utils/toastNotify';
import './AccessRequestButton.css';

const AccessRequestButton = () => {
  const { requestAccess } = useAuth();
  const [isRequesting, setIsRequesting] = useState(false);

  const handleRequestAccess = async () => {
    console.log('🔵 [Frontend] Запрос доступа начат');
    
    try {
      setIsRequesting(true);
      console.log('🔵 [Frontend] Вызываю requestAccess...');
      
      const result = await requestAccess();
      console.log('🔵 [Frontend] Получен результат:', result);
      
      if (!result) {
        console.error('❌ [Frontend] Результат пустой');
        toastNotify('Ошибка: не получен ответ от сервера', { type: 'error', duration: 4000 });
        return;
      }
      
      if (result.success) {
        console.log('✅ [Frontend] Успех!');
        toastNotify('Запрос доступа отправлен администратору. Ожидайте подтверждения.', { type: 'success', duration: 4000 });
      } else {
        const errorMsg = result.message || 'Неизвестная ошибка';
        console.error('❌ [Frontend] Ошибка:', errorMsg);
        console.error('❌ [Frontend] Полный результат:', JSON.stringify(result, null, 2));
        toastNotify('Ошибка: ' + errorMsg, { type: 'error', duration: 5000 });
      }
    } catch (error) {
      console.error('❌ [Frontend] Исключение:', error);
      console.error('❌ [Frontend] Stack:', error.stack);
      toastNotify('Ошибка при отправке запроса доступа: ' + error.message, { type: 'error', duration: 5000 });
    } finally {
      setIsRequesting(false);
    }
  };

  return (
    <div className="access-request-container">
      <div className="access-request-card">
        <h2 className="access-request-title">Доступ ограничен</h2>
        <p className="access-request-message">
          Для использования этого приложения необходимо получить доступ у администратора.
        </p>
        <button
          className="access-request-button"
          onClick={handleRequestAccess}
          disabled={isRequesting}
        >
          {isRequesting ? 'Отправка...' : 'Запросить доступ'}
        </button>
      </div>
    </div>
  );
};

export default AccessRequestButton;

